export default {
  getQuartes: 'pri/investment/analysis/getQuarters',
  brokeLine: 'pri/investment/analysis/position/brokeLine',
  assetAllocation: 'pri/investment/analysis/position/assetAllocation',
  //客户收益-折线图
  positionYieldCustomer: 'pri/investment/analysis/yield/customer',
  //客户产品收益
  positionYieldProduct: 'pri/investment/analysis/yield/product',
  //入口
  analysisEntry: 'pri/investment/analysis/investment/analysis/show',
};
